import { ReactElement } from 'react';

export function GdfAcceptanceContent(): ReactElement {
  return (
    <>
      <h2
        className="text-[2rem] font-semibold text-left text-primary-main notranslate"
        translate="no"
        lang="zxx"
      >
        Termo de aceite
      </h2>
      <p className="font-normal mt-1 text-justify mb-8">
        Confirmo minha adesão ao Auxílio Odontológico oferecido pelo Governo do
        Distrito Federal, conforme disposto no Diário Oficial de julho de 2024
        (Lei Nº 7.524 e Decreto Nº 46.102 de agosto de 2024).
      </p>
      <p className="font-normal mt-1 text-justify mb-8">
        O plano odontológico é 99% subsidiado para servidores titulares
        estaduais da administração direta, autárquica e fundacional do DF e está
        sendo disponibilizado através da Odontogroup Sistema de Saúde Ltda.,
        operadora credenciada.
      </p>
      <p className="font-normal mt-1 text-justify mb-8">
        Estou ciente que o plano não possui carência e requer uma permanência
        mínima de 12 meses.E reforço que estou ciente de que os meus dados
        pessoais serão tratados conforme as disposições da Lei Geral de Proteção
        de Dados (LGPD).
      </p>
    </>
  );
}
